export default function () {
    (function ($) {
        var linkAccountModal = $('#LinkAccountModal');

        // e.g $('.modal').linkAccountForm()
        $.fn.loadLinkAccountForm = function (src, force, callback) {
            var that = this;
            // Preserve the source
            $(this).attr('data-src', src);

            // Pre-load the modal content
            if (force || !$.trim($(this).find('.modal-body').html()).length) {
                $(this).find('.modal-body').load(src, function () {
                    $(this).find('[data-formid="linkaccount"]');
                    if (typeof callback === 'function') {
                        callback.call(that);
                    }
                });
            } else {
                // Callback anyway
                if (typeof callback === 'function') {
                    callback.call(that);
                }
            }
        };

        $.fn.resetLinkAccountForm = function () {
            var form = $('[data-formid="linkaccount"]');
            var validator = form.validate();

            // Assumes errors are always in a specific id
            $(this).find('.message').empty().removeClass('bad');
            // Reset validation
            if (validator) {
                form.find('input[type="text"]').removeClass('error');
                validator.resetForm();
            }
        };

        linkAccountModal.on('show.bs.modal hidden.bs.modal', function () {
            $(this).resetLinkAccountForm();
        });
        $('.cancel-link-account').on('click', function (e) {
            $(this).resetLinkAccountForm();
        });
        // Handles opening the link account modal
        $('[data-target="#LinkAccountModal"]').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $($(this).attr('data-target')).loadLinkAccountForm($(this).attr('href'), false, function () {
                $(this).modal('show');
            });
        });
        // Handles submitting the form
        linkAccountModal.on('submit', '[data-formid="linkaccount"]', function (event) {
            var form = $(event.currentTarget);
            var modal = $(this).closest('#LinkAccountModal');

            if (form.valid()) {
                $.ajax({
                    type: form.attr('method'),
                    url: form.attr('action'),
                    data: form.serialize(),
                    success: function (json) {
                        modal.loadLinkAccountForm(modal.attr('data-src'), true);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status == 403) {
                            location.reload();
                        }
                        modal.loadLinkAccountForm(modal.attr('data-src'), true);
                    },
                });

                return false;
            }

            return false;
        });
    })(jQuery);
}
